<template>
  <div>
    <a v-if="event.queued" 
       class="btn btn-block btn-outline-primary btn-lg" 
       :href="existingReservationLink">View your Reservation</a>

    <a v-else-if="!event.reservations_opened"
       class="btn btn-outline-dark btn-lg disabled btn-block">Reservations Will Open<br>{{format.datetime(event.reservations_opened_datetime)}}
    </a>


    <a v-else-if="event.cancelled" 
       class="btn btn-outline-danger btn-lg disabled btn-block">Event Cancelled</a>


    <a v-else-if="event.reservations_closed" 
       class="btn btn-outline-dark btn-lg disabled btn-block">Reservations Closed</a>

    <a v-else-if="event.stats.remaining_seats > 0" 
       class="btn btn-primary btn-block mt-2 btn-lg" 
       :href="newReservationLink" >Reserve now<span v-if="event.price > 0"> — {{format.currency(event.price)}}</span></a>

    <a v-else 
       class="btn btn-secondary btn-block mt-2 btn-lg" 
       :href="newReservationLink">Join the waitlist<span v-if="event.price > 0"> — {{format.currency(event.price)}}</span></a>
  </div>
</template>

<script>
export default {
  name: "ReserveButton",
  props: ["event"],
  computed: {
    newReservationLink() {
      return `/reservations/${this.event.id}/new`
    },
    existingReservationLink() {
      return `/home/reservations`
    }
  }
}
</script>